import { render } from "./Old_D1_Non.vue?vue&type=template&id=31cc4618"
import script from "./Old_D1_Non.vue?vue&type=script&lang=js"
export * from "./Old_D1_Non.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userSupport/Old_D1_Non.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31cc4618"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31cc4618', __exports__)) {
    api.reload('31cc4618', __exports__)
  }
  
  module.hot.accept("./Old_D1_Non.vue?vue&type=template&id=31cc4618", () => {
    api.rerender('31cc4618', render)
  })

}


export default __exports__